import React from 'react';
import Translate, {t} from "../../../../../../../../components/Translate";
import {setOperatorInactivityActionConfigCompanyId} from "../../../../../../../../services/company/api";
import {isPositiveInteger} from "../../../../../../../../utils/General";
import Input from "../../../../../../../../components-new/form/Input";
import colors from "../../../../../../../../utils/Colors";
import Switch from "../../../../../../../../components-new/form/Switch";
import SettingCard from "../../../../../../../../components-new/ui/SettingCard";

const inputStyle = {width: '100%', border: 'none', height: '38px', background: 'transparent'};

const OperatorInactivityAction = ({
                                      client,
                                      operatorInactivityAction,
                                      setOperatorInactivityAction,
                                      user,
                                      isFetching
                                  }) => {

    const handleEnabledCheckboxChange = (event) => {
        setOperatorInactivityAction({...operatorInactivityAction, enabled: event});
        operatorInactivityAction.enabled = event;
        setOperatorInactivityActionConfigCompanyId(client.id, {...operatorInactivityAction, enabled: event});
    };

    const handleTimeInputChange = (newValue) => {
        setOperatorInactivityAction({...operatorInactivityAction, time: newValue});
        operatorInactivityAction.time = newValue;
    }

    const handleTimeInputBlur = () => {
        setOperatorInactivityActionConfigCompanyId(client.id, {
            ...operatorInactivityAction,
            time: operatorInactivityAction.time
        });
    }

    const handleTextInputChange = (newValue) => {
        setOperatorInactivityAction({...operatorInactivityAction, text: newValue});
        operatorInactivityAction.text = newValue;
        setOperatorInactivityActionConfigCompanyId(client.id, {...operatorInactivityAction, text: newValue});
    }

    const validate = (value) => {
        isPositiveInteger(value);
        const parsedValue = Number(value);
        if (parsedValue < 1 || parsedValue > 60) {
            throw new Error('Wrong Range');
        }
    };

    const isOff = !operatorInactivityAction.enabled;
    const locked = isOff || isFetching;

    // hintKey carries the whole sentence about the range and what gets sent: on
    // the icon, where it is available and takes no room, rather than as a
    // paragraph the reader has to pass before reaching the fields it describes
    return (
        <SettingCard
            titleKey="operatorInactivityActionHeader"
            hintKey="operatorInactivityActionTimeExp"
            toggle={
                <Switch
                    checked={operatorInactivityAction.enabled}
                    onChange={handleEnabledCheckboxChange}
                    style={{color: colors.silverBlue}}
                />
            }
        >
            {/* no captions over these two: the unit says what the number is, the
                placeholder says what the text is, and the sentence behind the icon
                above says it once more. Packed rather than spread, so the pair
                reads as one setting. */}
            <div className={'setting-body setting-body--compact' + (isOff ? ' setting-body--off' : '')}>
                <div className="setting-field">
                    <div className="setting-number">
                        <div className="setting-number__box">
                            <Input
                                type={'number'}
                                style={inputStyle}
                                value={operatorInactivityAction.time ? operatorInactivityAction.time : ''}
                                validate={validate}
                                onChange={(event) => handleTimeInputChange(event.target.value)}
                                onBlur={() => handleTimeInputBlur()}
                                disabled={locked}
                                name={'op-inact-input'}
                            />
                        </div>
                        <span className="setting-number__unit"><Translate text={'min'}/></span>
                    </div>
                </div>

                <div className="setting-field">
                    <div className="setting-control">
                        <Input
                            placeholder={t({text: 'message', user})}
                            name={'text'}
                            value={operatorInactivityAction.text ? operatorInactivityAction.text : ''}
                            onChange={(e) => handleTextInputChange(e.target.value)}
                            disabled={locked}
                        />
                    </div>
                </div>
            </div>
        </SettingCard>
    );
};

export default OperatorInactivityAction;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/OperatorInactivityAction.jsx